import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from '@lib/models/DateTime';
import moment from 'moment';

@Pipe({
  name: 'dateTimeToNowDiff',
  standalone: true,
})
export class DateTimeToNowDiffPipe implements PipeTransform {
  transform(value: DateTime | string): string {
    let parsedTime;
    if (value instanceof DateTime) {
      parsedTime = value.moment;
    } else {
      parsedTime = DateTime.fromOlo(value).moment;
    }
    if (parsedTime.isAfter(moment())) {
      return parsedTime.fromNow();
    }
    return parsedTime.toNow();
  }
}
